import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Heading from "~components/atoms/heading/heading";
import RichText from "~components/molecules/rich_text/rich_text";
import useAccordionTransitions from "~hooks/use_accordion_transitions/use_accordion_transitions";
import useMatchMedia from "~hooks/use_match_media/use_match_media";
import { COLOR, RICH_TEXT } from "../../../../../prop_types";
import * as classes from "./accordion_item.module.scss";

const formatNumber = (number) => {
  return number ? number.toString().padStart(2, "0") : null;
};

export default function AccordionItem({
  index,
  title,
  color,
  description,
  isActive,
  onClick,
}) {
  const ref = useAccordionTransitions(isActive);
  const isTabletOrDesktopWindow = useMatchMedia({ min: "S" });
  const handleButtonClick = useCallback(() => {
    onClick(index);
  }, [index, onClick]);

  const classNames = [classes.accordionItem];

  if (isActive) {
    classNames.push(classes.isActive);
  }

  const style = {};

  if (color?.color) {
    style.color = color.color;
  }

  return (
    <button
      type="button"
      className={classNames.join(" ")}
      onClick={handleButtonClick}
    >
      <div className={classes.grid}>
        <div className={classes.icon} style={style}>
          <div className={classes.number}>{formatNumber(index + 1)}</div>
        </div>
        <div className={classes.title}>
          <Heading seoLevel="5" visualLevel={7} isUppercase>
            {title}
          </Heading>
        </div>
        {isTabletOrDesktopWindow && (
          <div className={classes.chevron} style={style}>
            <svg>
              <use xlinkHref="/images/icon_plus.svg#icon" />
            </svg>
          </div>
        )}
      </div>
      <div className={classes.content} ref={ref}>
        <div className={classes.grid}>
          <RichText text={description} />
        </div>
      </div>
    </button>
  );
}

AccordionItem.defaultProps = {
  title: null,
  color: null,
  description: null,
  isActive: false,
  onClick: () => {},
};

AccordionItem.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string,
  color: COLOR,
  description: RICH_TEXT,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};
